import Dialog from '@mui/material/Dialog';
import { Button, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { useContext } from 'react';
import { CreateInvoicesValues, InvoicesContext } from '../contexts/InvoicesContext';
import { CloseDialogAction } from '../../../components/shared/dialogs/CloseDialogAction';

export function ConfirmModal() {
  const { t, closesAcceptModal, isOpenModal, handleAcceptClick, acceptId } = useContext(InvoicesContext) as CreateInvoicesValues;


  return (
    <Dialog onClose={closesAcceptModal}
      open={isOpenModal}>
      <DialogTitle> {t('modalHeader')}</DialogTitle>
      <DialogContent>
        {t('modalTitle')}
        <CloseDialogAction onCancel={closesAcceptModal} />
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='6px'
          width='100%'>
          <Button variant='secondary'
            fullWidth
            size="lg"
            onClick={closesAcceptModal}>
            {t('close')}
          </Button>
          <Button variant='primary'
            fullWidth
            size="lg"
            onClick={() => handleAcceptClick(acceptId ?? -1)}>
            {t('accept')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
